import { useEffect, useState } from "react";
import { admin, type Run } from "../../api/admin";
import { Counters, StateBadge, StopRun, took, when } from "./bits";

export function Runs({ onWatch }: { onWatch: (id: number) => void }) {
  const [runs, setRuns] = useState<Run[] | null>(null);
  const [state, setState] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      admin.runs({ state: state || undefined, limit: 100 })
        .then((r) => alive && setRuns(r))
        .catch((e: Error) => alive && setError(e.message));
    load();
    const t = setInterval(load, 3000);
    return () => { alive = false; clearInterval(t); };
  }, [state]);

  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <div className="controls">
        <select value={state} onChange={(e) => setState(e.target.value)}>
          <option value="">Every run</option>
          {["queued", "running", "succeeded", "failed", "cancelled"].map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      {!runs && <div className="loading"><span className="spinner" />loading…</div>}
      {runs?.length === 0 && <div className="empty">Nothing has run yet.</div>}

      {runs && runs.length > 0 && (
        <table className="runs">
          <thead>
            <tr>
              <th>run</th><th>job</th><th>state</th><th>started</th>
              <th>took</th><th>by</th><th>what it did</th><th></th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id} onClick={() => onWatch(r.id)}>
                <td className="num">{r.id}</td>
                <td><code>{r.kind}</code></td>
                <td><StateBadge state={r.state} /></td>
                <td className="dim">{when(r.startedAt ?? r.queuedAt)}</td>
                <td className="dim">{took(r)}</td>
                <td className="dim">{r.triggeredBy}</td>
                <td>
                  <Counters counters={r.counters} />
                  {r.error && <span className="failmsg">{r.error}</span>}
                </td>
                <td className="ops"><StopRun run={r} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
